/* sts-filter-panel.js: the Filters button and its one panel (Roger, 2026-09-29).

   Every native filter sits behind "Filters" (snippets/sts-collection-filters.liquid);
   only the skin-type toggle stays in the row. The panel is a bottom sheet to 860px
   and a side drawer from the right above (assets/sts-filter-panel.css).

   It COLLECTS: a tap ticks the box at once, with no request. The section for the
   ticked state is then fetched in the background (250ms after the last tap, the
   latest answer wins), so "Show N results" and every option's count are the real
   ones, and that same HTML is what "Show N results" swaps in: one render per visit
   to the panel, never a reload per tap. Every other way out (the x, the scrim,
   Escape) applies the ticks too, so nothing the shopper chose is dropped. Clear all
   unticks everything here; the skin-type filter is not in the panel, so it stays.

   The sheet (the move to <body>, scrim, inert page, focus trap, the STS.scroll lock
   and its no-move close) and the swap are assets/sts-collection.js's, reached
   through STS.coll. Loaded after it, on the collection and search sections only. */
(function (w, d) {
  'use strict';
  var S = w.STS = w.STS || {};
  if (S.fpanelBooted) return;
  S.fpanelBooted = true;

  var PRICE = 'filter.v.price';
  var root = null, panel = null, want = null, got = null, timer = 0, applying = false;

  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  function C() { return S.coll; }
  function showBtn() { return panel && panel.querySelector('[data-sts-fall-show]'); }

  /* This page's URL with every param the panel owns replaced by what is ticked,
     and page dropped. Everything else (skin type, sort, q, utm) is kept. */
  function build() {
    var u = new URL(w.location.href), p = u.searchParams;
    $$('[data-sts-fopt]', panel).forEach(function (o) {
      var k = o.getAttribute('data-param');
      if (k === PRICE) { p.delete(k + '.gte'); p.delete(k + '.lte'); } else p.delete(k);
    });
    p.delete('page');
    $$('[data-sts-fopt][aria-checked="true"]', panel).forEach(function (o) {
      var k = o.getAttribute('data-param');
      if (k !== PRICE) { p.append(k, o.getAttribute('data-value')); return; }
      if (o.getAttribute('data-gte')) p.append(k + '.gte', o.getAttribute('data-gte'));
      if (o.getAttribute('data-lte')) p.append(k + '.lte', o.getAttribute('data-lte'));
    });
    var q = p.toString();
    return u.pathname + (q ? '?' + q : '');
  }
  /* The filter params of a URL, in any order: "changed" versus "the same".
     A price bound is a number whichever way it was written (50 or 50.00). */
  function canon(url) {
    var out = [];
    new URLSearchParams(url.split('?')[1] || '').forEach(function (v, k) {
      if (k.indexOf('filter.') === 0) out.push(k + '=' + (/\.[gl]te$/.test(k) ? +v : v));
    });
    return out.sort().join('&');
  }
  function changed() { return canon(build()) !== canon(w.location.search); }

  function label(n) {
    var b = showBtn();
    if (b) b.textContent = 'Show ' + n + (n === 1 ? ' result' : ' results');
  }

  function mark(o, on) {
    o.setAttribute('aria-checked', on ? 'true' : 'false');
    o.classList.toggle('is-on', on);
  }
  /* A section's badge: how many of its options are ticked. */
  function sec(s) {
    var n = s && s.querySelector('[data-sts-fsec-n]');
    if (!n) return;
    var k = $$('[data-sts-fopt][aria-checked="true"]', s).length;
    n.textContent = k;
    n.hidden = !k;
  }
  /* Each option's count for the ticked state (doc), or back to the page's (null).
     An option the answer leaves out has none left: Shopify drops a 0 unless ticked. */
  function counts(doc) {
    var fresh = {};
    if (doc) {
      $$('[data-sts-fall] [data-sts-fopt]', doc).forEach(function (o) {
        var c = o.querySelector('.sts-fopt__count');
        if (c) fresh[o.getAttribute('data-param') + '&' + o.getAttribute('data-value')] = c.textContent;
      });
    }
    $$('[data-sts-fopt]', panel).forEach(function (o) {
      var c = o.querySelector('.sts-fopt__count');
      if (!c) return;
      if (o.stsN == null) o.stsN = c.textContent;
      var f = fresh[o.getAttribute('data-param') + '&' + o.getAttribute('data-value')];
      c.textContent = doc ? (f == null ? '0' : f) : o.stsN;
    });
  }

  function refresh() {
    var url = build(), b = showBtn();
    w.clearTimeout(timer);
    if (!changed()) {
      want = got = null;
      if (b) b.removeAttribute('aria-busy');
      label(+root.getAttribute('data-count') || 0);
      counts(null);
      return;
    }
    want = url;
    if (b) b.setAttribute('aria-busy', 'true');
    timer = w.setTimeout(function () {
      var p = C().get(root, url);
      got = { url: url, p: p };
      p.then(function (html) {
        if (want !== url) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sts-collection]');
        if (b) b.removeAttribute('aria-busy');
        label(fresh ? +fresh.getAttribute('data-count') || 0 : 0);
        counts(doc);
      }, function () { if (want === url && b) b.removeAttribute('aria-busy'); });
    }, 250);
  }

  function tick(o) {
    var on = o.getAttribute('aria-checked') !== 'true';
    /* Price is one band at a time (decision 04-Q17). */
    if (on && o.hasAttribute('data-single')) {
      $$('[data-single]', o.closest('ul') || panel).forEach(function (x) { mark(x, false); });
    }
    mark(o, on);
    sec(o.closest('.sts-fsec'));
    refresh();
  }

  function clearAll() {
    $$('[data-sts-fopt]', panel).forEach(function (o) { mark(o, false); });
    $$('.sts-fsec', panel).forEach(sec);
    refresh();
  }

  /* Swap in the ticked state: the HTML already fetched for it when there is
     one. False when nothing changed. */
  function apply() {
    var r = root, url = build(), g = got;
    if (!changed()) return false;
    applying = true;
    w.clearTimeout(timer);
    /* Ticks made now would be dropped: the panel waits (open() lifts it). */
    panel.setAttribute('aria-busy', 'true');
    function go(html) {
      var q = C().apply(r, url, html ? { html: html } : null);
      /* The button the focus went back to was redrawn with the grid. */
      if (q) q.then(function () {
        var fb = r.querySelector('[data-sts-fbtn]');
        if (fb && (!d.activeElement || d.activeElement === d.body)) fb.focus({ preventScroll: true });
      });
    }
    if (g && g.url === url) g.p.then(go, function () { go(null); });
    else go(null);
    return true;
  }

  /* STS.coll.close() calls this after any close; a swap closes the sheet too. */
  function closed() {
    if (!applying) apply();
    w.clearTimeout(timer);
    panel = null;
  }

  function open(btn) {
    var r = btn.closest('[data-sts-collection]');
    var p = r && d.getElementById(btn.getAttribute('aria-controls'));
    if (!p || !C()) return;
    root = r; panel = p; want = got = null; applying = false;
    p.removeAttribute('aria-busy');
    /* Ticks never applied (a swap that could not start) do not come back. */
    $$('[data-sts-fopt]', p).forEach(function (o) {
      if (o.stsWas == null) o.stsWas = o.getAttribute('aria-checked') === 'true';
      else mark(o, o.stsWas);
    });
    $$('.sts-fsec', p).forEach(sec);
    counts(null);
    label(+r.getAttribute('data-count') || 0);
    var b = showBtn();
    if (b) b.removeAttribute('aria-busy');
    p.stsOnClose = closed;
    C().open(btn, p);
  }

  d.addEventListener('click', function (e) {
    var t = e.target, o;
    if (!t || !t.closest) return;
    if ((o = t.closest('[data-sts-fbtn]'))) { e.preventDefault(); open(o); return; }
    if (!panel || !panel.contains(t)) return;
    if ((o = t.closest('[data-sts-fopt]'))) { e.preventDefault(); tick(o); return; }
    if (t.closest('[data-sts-fall-clear]')) { e.preventDefault(); clearAll(); return; }
    if (t.closest('[data-sts-fall-show]')) {
      e.preventDefault();
      if (!apply()) C().close();
      return;
    }
    if (t.closest('[data-sts-fclose]')) { e.preventDefault(); C().close(); }
  });

  /* The options are role="checkbox" links: Space ticks, as on a checkbox. */
  d.addEventListener('keydown', function (e) {
    if (e.key !== ' ' || !panel || !e.target.closest) return;
    var o = e.target.closest('[data-sts-fopt]');
    if (o && panel.contains(o)) { e.preventDefault(); tick(o); }
  });
})(window, document);
